import React, { useState, useEffect, Suspense } from 'react';
import { Layout } from './containers/Layout'
//import { CipherView } from './containers/CipherView'
//import { TextView } from './containers/TextView'
//import { MiscView } from './containers/MiscView'
const LazyCipherView = React.lazy(() => import('./containers/CipherView'));
const LazyTextView = React.lazy(() => import('./containers/TextView'));
const LazyMiscView = React.lazy(() => import('./containers/MiscView'));
const LazyTestView = React.lazy(() => import('./containers/TestView'));

//import { BrowserRouter as Router } from 'react-router-dom'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './components/shared/Home';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import LinearProgress from '@mui/material/LinearProgress';
import { ProgressBar } from './components/shared/ProgressBar';
import { NotFound } from './components/shared/NotFound';
import { Redirector } from './components/shared/Redirector';



function App() {

    const [State, setState] = useState({
        messageIsError: false, message: '', messageDelay: ''
    })

    const showMessage = (msg, isError, keepShown = false, messageDelay = '5000') => {

        setState(prevState => ({
            ...prevState,
            'message': msg == prevState.message ? msg += ' ' : msg,
            'messageIsError': isError,
            'messageDelay': messageDelay,
            'keepShown': keepShown

        }))
    }

    const helmetContext = {};

    return (
        <>
            <HelmetProvider context={helmetContext}>
                <Router>
                    <Layout message={State.message} messageIsError={State.messageIsError} keepShown={State.keepShown} messageDelay={State.messageDelay} showMessage={showMessage}>
                        <Suspense fallback={<ProgressBar isVisible={true} />}>
                            <Routes>
                                <Route path='/' element={<Home />}></Route>
                                <Route path='/cipher-tools/*' element={<LazyCipherView showMessage={showMessage} />}></Route>
                                <Route path='/text-tools/*' element={<LazyTextView showMessage={showMessage} />}></Route>
                                <Route path='/misc-tools/*' element={<LazyMiscView showMessage={showMessage} />}></Route>
                                <Route path='/test/*' element={<LazyTestView showMessage={showMessage} />}></Route>
                                <Route path='/not-found' element={<NotFound />}></Route>
                                <Route path='*' element={<Redirector />}></Route>
                            </Routes>
                        </Suspense>
                    </Layout>
                </Router>
            </HelmetProvider>
        </>
    );
}

export default App;
